/*
  strip spaces if value is a number
 */
import {REGEX_INTEGER} from "../constants/regex";

export default function formatSiretSiren(value) {
  const regex = RegExp(REGEX_INTEGER);
  if (regex.test(value)) {
    return value.replace(/ /g, '');
  } else {
    return value;
  }
}